<template>
    <div class="card">
        <div class="card-header bg-transparent text-left">
            <div class="row">
                <div class="col-10 text-left">
                    <strong>Faturamento de hoje por hora</strong>
                </div>
                <div class="col-2 text-right">
                    <font-awesome-icon icon="sync" @click="updateData()" rel="tooltip" title="Atualizar dados do gráfico" role="button" />
                </div>
            </div>
        </div>

        <div class="card-body">
            <revenues-per-hour
                v-if="isLoading"
                :options="options"
                :chart-data="chartdata"
            />
            <font-awesome-icon v-else icon="spinner" size="2x" spin  />
        </div>

        <div class="card-footer">
            <div class="row">
                <div class="col-md-6 text-md-left text-center">
                    <strong>Valor total:</strong> {{total}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import revenuesPerHour from '@/components/graphs/revenuesPerHour.vue'
    export default {
        name: 'wdgRevenuesPerHour',
        components:{
          revenuesPerHour
        },
        computed: {
            getToken: function(){
                return this.$store.getters.getToken
            }
        },
        data(){
          return {
                total: 0,
                isLoading: false,
                chartdata: {
                    labels  : [],
                    datasets: []
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {

                        }
                    }
                }
          }
        },
        methods: {
            updateData: function(){
                let url = server + 'graficos/vendas/periodo/hora'
                this.isLoading = false
                fetch(url, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        let data = responseJSON.response
                        let labels = []
                        let dtset   = []

                        this.chartdata.labels = []
                        this.chartdata.datasets = []

                        this.total = 0

                        const formatter = new Intl.NumberFormat('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                            minimumFractionDigits: 2
                        })

                        for (let index = 0; index < data.length; index++) {
                            const element = data[index];
                            labels.push(element.PERIODO)

                            dtset.push(element.TOTAL_LIQUIDO)
                            this.total = parseFloat(this.total) + parseFloat(element.TOTAL_LIQUIDO)
                        }

                        this.total = formatter.format(this.total)
                        this.options.tooltips.callbacks.label = function(tooltipItem, data){
                            return  'Valor ' + formatter.format(data.datasets[0].data[tooltipItem.index])
                        }
                        this.options.tooltips.callbacks.title = function(tooltipItems, data){
                            var tooltipItem = tooltipItems[0];

                            return  data.labels[tooltipItem.index] + ' Horas' 
                        }

                        this.chartdata.labels = labels
                        this.chartdata.datasets.push({
                            label: 'Valor',
                            backgroundColor: '#28a745',
                            data: dtset
                        })

                        this.isLoading = true
                    })
                    .catch(error => (console.log(error)));
            }
        },
        mounted () {
            this.updateData()
        }

    }
</script>